import {
    TechRadarLoaderResponse,
  } from '@backstage-community/plugin-tech-radar-common';

import {
    TechRadarApi,
  } from '@backstage-community/plugin-tech-radar';
  
  export class techRadarCustomClient implements TechRadarApi {
    async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
      // if needed id prop can be used to fetch the correct data
  
      const data = await fetch('tech-radar.json').then(res => res.json());
  
      // For example, this converts the timeline dates into date objects
      return {
        ...data,
        entries: data.entries.map((entry: { timeline: any[]; }) => ({
          ...entry,
          timeline: entry.timeline.map(timeline => ({
            ...timeline,
            date: new Date(timeline.date),
          })),
        })),
      };
    }
  }